import { render, staticRenderFns } from "./MainTain.vue?vue&type=template&id=aa3ea8d0&scoped=true&"
import script from "./MainTain.vue?vue&type=script&lang=js&"
export * from "./MainTain.vue?vue&type=script&lang=js&"
import style0 from "./MainTain.vue?vue&type=style&index=0&id=aa3ea8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3ea8d0",
  null
  
)

export default component.exports